import { render, staticRenderFns } from "./IsOlder.vue?vue&type=template&id=21653a84&scoped=true&lang=pug&"
import script from "./IsOlder.vue?vue&type=script&lang=js&"
export * from "./IsOlder.vue?vue&type=script&lang=js&"
import style0 from "./IsOlder.vue?vue&type=style&index=0&id=21653a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21653a84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21653a84')) {
      api.createRecord('21653a84', component.options)
    } else {
      api.reload('21653a84', component.options)
    }
    module.hot.accept("./IsOlder.vue?vue&type=template&id=21653a84&scoped=true&lang=pug&", function () {
      api.rerender('21653a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/IsOlder.vue"
export default component.exports